import { HealthSystemDomainDiseasesDiseaseViewModel } from '../api/HealthSystemApi';

export interface DiseaseInfoProps {
  diseases: HealthSystemDomainDiseasesDiseaseViewModel[];
}

export default function DiseaseInfo({ diseases }: DiseaseInfoProps) {
  if (!diseases.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {diseases.map((disease) => {
        const colour = disease.stableColours?.[0]?.colour;
        return (
          <div
            key={disease.id}
            className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-gray-700"
          >
            {colour && <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ backgroundColor: colour }} />}
            {disease.name}
          </div>
        );
      })}
    </div>
  );
}
